import React from "react";
import { Modal, notification } from "antd";
import { reviewModalConstants, reviewValidationSchema } from "../constants";
import Form from "../../../Form";
import InputField from "../../../../reusable-components/TNInputField";
import { InputfieldTypes } from "../../../../enums/InputFieldAttributesEnums";
import TicketProcessingServices from "../../../../services/ticketProcessing.service";
import { TicketSubmitAction } from "../../../../enums/TicketProcessingReview.enum";
import { useQueryClient } from "@tanstack/react-query";
import TNLoader from "../../../../reusable-components/TNLoader";

interface ManagerReviewModalProps {
  isOpen: boolean;
  handleClose: () => void;
  activeTicketId: string;
  handleInputReset: () => void;
  successMsgTrigger: () => void;
}

const ManagerReviewModal = (props: ManagerReviewModalProps) => {
  const {
    isOpen,
    handleClose,
    activeTicketId,
    handleInputReset,
    successMsgTrigger,
  } = props;
  const queryClient = useQueryClient();
  const { SubmitTicketProcessingReview } = TicketProcessingServices();
  const { mutateAsync, isPending: moveToManagerPending } =
    SubmitTicketProcessingReview();

  return (
    <>
      <TNLoader isLoading={moveToManagerPending} />
      <Form validationSchema={reviewValidationSchema}>
        {({ getValues, control: { handleSubmit, _formState, _reset } }) => {
          const handleCancelAction = () => {
            _reset();
            handleClose();
          };

          const handleSubmitAction = async () => {
            const payloadData = {
              id: activeTicketId,
              ticketVerification: TicketSubmitAction.REVIEW,
              reviewReason: getValues(reviewModalConstants.TEXTBOX_NAME),
            };
            await mutateAsync(payloadData, {
              onSuccess: () => {
                handleClose();
                successMsgTrigger();
                _reset();
                handleInputReset();
              },
            });
          };

          return (
            <Modal
              visible={isOpen}
              onCancel={handleCancelAction}
              title={reviewModalConstants.TITLE}
              okText={reviewModalConstants.SUBMIT_BTN_TXT}
              onOk={handleSubmit(() => handleSubmitAction())}
              width={reviewModalConstants.WIDTH}
            >
              <InputField
                type={InputfieldTypes.TEXT_AREA}
                name={reviewModalConstants.TEXTBOX_NAME}
                label={reviewModalConstants.TEXTBOX_LABEL}
                textAreaRows={reviewModalConstants.TEXTBOX_ROWS}
                placeholder={reviewModalConstants.TEXTBOX_PLACEHOLDER}
                requiredField={true}
              />
            </Modal>
          );
        }}
      </Form>
    </>
  );
};

export default ManagerReviewModal;
